import { useTranslation } from 'react-i18next';

import { Button, Modal, Paragraph, Subheading, TextBubble } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

export default function SpontaneousFeedbackModal(props: {
	request: graphql.FeedbackRequest;
	onDismiss: () => void;
	onContinue: () => void;
}) {
	const { t } = useTranslation();

	const response = props.request.responses.edges[0]?.node;

	if (!response) {
		return null;
	}

	return (
		<Modal>
			<Modal.Header
				title={t('feedback.spontaneous.warning.title', {
					name: response.recipient.firstName,
				})}
			/>
			<Modal.Contents>
				<Paragraph mb={3}>
					{t('feedback.spontaneous.warning.description', { name: response.recipient.firstName })}
				</Paragraph>
				<Subheading mb={3}>{props.request.title}</Subheading>
				<TextBubble user={response.recipient} text={props.request.instruction} />
			</Modal.Contents>
			<Modal.Footer>
				<Button
					type="secondary"
					title={t('feedback.spontaneous.warning.cancel')}
					onClick={props.onDismiss}
				/>
				<Button
					type="primary"
					title={t('feedback.spontaneous.warning.continue')}
					onClick={props.onContinue}
					ml={2}
				/>
			</Modal.Footer>
		</Modal>
	);
}
